import { Bot } from "lucide-react";
import { Link } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";

const PatientAssistantFab = () => {
  const { language } = useLanguage();
  const bn = language === "bn";

  return (
    <Link
      to="/patient-symptom-assistant"
      aria-label={bn ? "স্বাস্থ্য সহায়ক খুলুন" : "Open health assistant"}
      className="fixed bottom-24 right-4 z-40 inline-flex items-center gap-2 rounded-full border border-[#b8ddd0] bg-[#174e49] px-4 py-3 text-xs font-bold text-white shadow-[0_10px_24px_rgba(23,78,73,0.24)] transition-transform hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-[#71b9aa] focus:ring-offset-2 sm:right-6"
    >
      <Bot className="h-4 w-4" />
      {bn ? "স্বাস্থ্য সহায়ক" : "Ask assistant"}
    </Link>
  );
};

export default PatientAssistantFab;